import React from 'react';
import {addEventListener} from "consolidated-events";

function hasIntersectionObserverSupport(w) {
  return 'IntersectionObserver' in w && 'isIntersecting' in w.IntersectionObserverEntry.prototype;
}

export default class PageLoader extends React.Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
    this.measure = this.measure.bind(this);
    this.run = this.run.bind(this);
  }

  componentDidMount() {
    this.setState(() => {
      if (hasIntersectionObserverSupport(window)) {
        this.observer = new IntersectionObserver(this.run, { rootMargin: `0px 0px ${this.props.threshold}px 0px` });
        this.observer.observe(this.ref.current);
        console.log(this.observer);
      } else {
        this.unsub = addEventListener(
          window,
          'scroll',
          this.measure,
          {passive: true}
        );
      }

      return { viewportBottomEdge: window.innerHeight };
    });
  }

  componentWillUnmount() {
    if (hasIntersectionObserverSupport(window)) {
      this.observer.unobserve(this.ref.current);
      this.observer.disconnect();
    } else {
      this.unsub();
    }
  }

  measure() {
    let { viewportBottomEdge } = this.state;
    let { listener, threshold } = this.props;

    if (!this.ref || !listener) { return; }

    let { top } = this.ref.current.getBoundingClientRect();

    if (top < viewportBottomEdge + threshold) {
      listener();
    }
  }

  run(e) {
    if (this.props.listener && e && e.length && e[0].isIntersecting) {
      this.props.listener();
    }
  }

  render() {
    return <span ref={this.ref} />;
  }
}